module.exports = __webpack_public_path__ + "static/media/globo.c7a8f80b.svg";